import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [{ title: 'Site Map' }]

const SiteMap = () => (
	<main className="mx-auto my-10 max-w-7xl">
		<Link prefetch="intent" to="/" className="text-blue-600 underline">
			Home
		</Link>

		<h1 className="py-3 text-4xl font-black">Site Map</h1>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			A directory of pages on this site.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			<ul>
				<li>
					<Link
						to="/articles/"
						className="text-blue-600 underline"
						prefetch="intent"
					>
						Articles
					</Link>
				</li>
				<li>
					<Link
						to="/careers/"
						className="text-blue-600 underline"
						prefetch="intent"
					>
						Careers
					</Link>
				</li>
				<li>
					<Link
						prefetch="intent"
						to="/frequently-asked-questions/"
						className="text-blue-600 underline"
					>
						Frequently Asked Questions
					</Link>
				</li>
				<li>
					<Link
						prefetch="intent"
						to="/our-insurance-company-relationships/"
						className="text-blue-600 underline"
					>
						Insurance Companies
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/"
						className="text-blue-600 underline"
						prefetch="intent"
					>
						Products and Programs
					</Link>
				</li>
			</ul>
		</p>
	</main>
)

export default SiteMap
